var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortAsc12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95051 4.06204L6.53316 2.64469L5.66774 1.77486C5.30127 1.40838 4.70519 1.40838 4.33871 1.77486L2.05153 4.06204C1.75128 4.36229 1.96764 4.87447 2.3871 4.87447H4.86414H7.61494C8.03882 4.87447 8.25076 4.36229 7.95051 4.06204Z",
    fill: "#FD8A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61474 7.125H4.8628H2.38472C1.96067 7.125 1.74864 7.6374 2.04901 7.93777L4.33714 10.2259C4.70378 10.5925 5.3001 10.5925 5.66673 10.2259L6.53693 9.35571L7.95487 7.93777C8.25082 7.6374 8.03879 7.125 7.61474 7.125Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc12);
export default __webpack_public_path__ + "static/media/sort-asc-12.e122b9b8a506e589f6a992f0aeeaf3cf.svg";
export { ForwardRef as ReactComponent };